import axios from '../helpers/axios'
import { logError } from '../services';
import { IPlantList } from '../models';

export const getPlantLists = async (): Promise<IPlantList[]> => {
  try {
    const { data } = await axios.get(`/api/admin/plant-lists`);
    return data;
  } catch (error) {
    logError(error, 'getPlantLists failed');
    return Promise.reject(error);
  }
};

export const updatePlantLists = async (post: IPlantList[]): Promise<IPlantList[]> => {
  try {
    const { data } = await axios.post(`/api/admin/plant-lists`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'updatePlantLists failed');
    return Promise.reject(error);
  }
};
